// ══════════════════════════════════════════════
//  增值订单：订单来源 / 应用方向 选项与展示工具
//  适用：平台端（增值服务订单管理）、企业端（增值订单查询）
//  TODO: 联调时与后端枚举对齐
// ══════════════════════════════════════════════

/**
 * 订单来源级联选项
 * 赠送
 * 购买
 *   ├ 全部（等于不选择）
 *   ├ 常规购买
 *   └ 活动专享
 *       ├ 全部（等于不选择）
 *       └ 单次解锁事件记录
 */
export const ORDER_SOURCE_OPTIONS = [
  { value: '赠送', label: '赠送' },
  {
    value: '购买',
    label: '购买',
    children: [
      { value: '全部', label: '全部' },
      { value: '常规购买', label: '常规购买' },
      {
        value: '活动专享',
        label: '活动专享',
        children: [
          { value: '全部', label: '全部' },
          { value: '单次解锁事件记录', label: '单次解锁事件记录' },
        ],
      },
    ],
  },
];

/**
 * 应用方向级联选项
 * 用户
 * 设备
 *   ├ 全部（等于不选择）
 *   ├ 单设备
 *   └ 多设备
 */
export const APP_DIRECTION_OPTIONS = [
  { value: '用户', label: '用户' },
  {
    value: '设备',
    label: '设备',
    children: [
      { value: '全部', label: '全部' },
      { value: '单设备', label: '单设备' },
      { value: '多设备', label: '多设备' },
    ],
  },
];

/** 订单来源标签颜色 */
export const ORDER_SOURCE_COLORS = {
  赠送: 'green',
  购买: 'blue',
  常规购买: 'cyan',
  活动专享: 'purple',
  单次解锁事件记录: 'orange',
};

/** 应用方向标签颜色 */
export const APP_DIRECTION_COLORS = {
  用户: 'geekblue',
  设备: 'blue',
  单设备: 'cyan',
  多设备: 'purple',
};

/** 「全部」等于不选择：把级联路径截断到「全部」之前 */
export const normalizeCascadePath = (path) => {
  if (!Array.isArray(path) || path.length === 0) return [];
  const idx = path.indexOf('全部');
  return idx === -1 ? path : path.slice(0, idx);
};

/** 订单来源逐行标签：['购买','活动专享','单次解锁事件记录'] */
export const getOrderSourceLabels = (orderSource) => (Array.isArray(orderSource) ? orderSource : []);

/** 应用方向逐行标签（两个字段拼接）：设备 → ['设备','单设备']；用户 → ['用户'] */
export const getAppDirectionLabels = (record) => {
  if (!record || !record.appDirection) return [];
  return record.appDirection === '设备' && record.deviceScope
    ? [record.appDirection, record.deviceScope]
    : [record.appDirection];
};

/** 单次解锁订单：无套餐信息、不涉及商务结算，不支持退款 */
export const isUnlockOrder = (record) => getOrderSourceLabels(record?.orderSource).includes('单次解锁事件记录');

/** 订单来源匹配：查询路径为订单来源的前缀即命中 */
export const matchOrderSource = (orderSource, queryPath) => {
  const path = normalizeCascadePath(queryPath);
  if (path.length === 0) return true;
  const labels = getOrderSourceLabels(orderSource);
  if (labels.length === 0) return false;
  return path.every((seg, i) => labels[i] === seg);
};

/** 应用方向匹配：查询路径为应用方向标签的前缀即命中 */
export const matchAppDirection = (record, queryPath) => {
  const path = normalizeCascadePath(queryPath);
  if (path.length === 0) return true;
  const labels = getAppDirectionLabels(record);
  if (labels.length === 0) return false;
  return path.every((seg, i) => labels[i] === seg);
};
